import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgToegankelijkWonen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="m18 8 10 8v16H8V16z"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      d="M16 22h-6v10h6zM23.5 26a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M17.444 13.594a7.002 7.002 0 1 0 9.902 9.902l.707.708a8.002 8.002 0 1 1-11.317-11.318z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M21.44 20.23h-3.06V19l2-4.52 1.51.61-1.48 3.51h1v-1.3h1.71v1.3h.72v1.63h-.72v1.16h-1.68zM24.5 20.8l.63-1.26a2.6 2.6 0 0 0 1.48.45c.81 0 1.14-.36 1.14-.77s-.54-.68-1.27-.68a2.8 2.8 0 0 0-1.12.26l-.58-.59v-3.45h4.4v1.63h-2.54v.73q.245-.023.49 0c1.2 0 2.49.61 2.49 2 0 1.62-1.31 2.4-2.93 2.4a3.62 3.62 0 0 1-2.19-.72"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M29.53 12V8h1v4z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M28.03 9.5h4v1h-4z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgToegankelijkWonen);

export default ForwardRef;
